import moment from "moment-jalali";
import { useEffect, useRef, useState } from "react";
import ProductSelectionPanel from "./ProductSelection/ProductSelectionPanel";
import { Button, Card, Col, Form, OverlayTrigger, Popover, Row } from "react-bootstrap";
import CustomerPanel from "./CustomerPanel/CustomerPanel";
import { getSystemSettingsAsync } from "../../../store/api/SystemSettingsAPI";
import './NewInvoice.css';
import { getBaseInfoList } from "../../../BaseInfo/store/api/BaseInfoApi";

import {
    Pencil,
    Trash,
    CheckLg,
    Printer,
    FileEarmarkPlus,
    Trash3,
    PrinterFill,
    CaretRight
} from "react-bootstrap-icons";

import DataTable from "../../../Components/DataTable/DataTable";
import { getProductGroups } from "../../../store/api/GetAllProduct";
import {
    getSettingBoolValue,
    getSettingNumberValue,
    invoiceTypes,
    setErrorDialog,
    validateMobile
} from "../../../store/api/CommonFunctions";
import { addEditInvoiceAync, deleteInvoice, getInvoiceAsync, getInvoiceNewNumber, getPrvNextInvoiceID, getPrvNextInvoiceIDAsync } from "../../store/api/Invoice";
import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import ModalPrintViewer from "../../../Components/Modals/ModalPrintViewer";
import { addNewCustomerAsync, getDefaultCustomerIDAsync } from "../../../CRM/store/api/CustomerApi";
import { setDialog } from "../../store/api/GetAllProduct";
import InvoiceTopHead from "./InvoiceTopHead";
import InvoiceTotalPrices from "./InvoiceTotalPrices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight, faFileInvoice } from "@fortawesome/free-solid-svg-icons";

const NewInvoice = () => {
    const panelProductsRef = useRef();
    const panelDetailsRef = useRef();

    const dispatch = useDispatch();

    const now = new Date();
    const time = now.toLocaleTimeString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit'
    });
    const initData = {
        InvoiceDetailList: [],
        ContactDate: now.toLocaleString("en-US", { hour12: false }),
        PContactDate: moment().format("jYYYY/jMM/jDD"),
        PContactHour: time,
        Discount: 0,
        TaxFee: 0,
        InvoiceTotalPrice: 0,
        InvoicePureTotalPrice: 0,
        IsFormal: true
    }

    const [invoiceData, setInvoiceData] = useState({ ...initData });


    const [productGroups, setProductGroups] = useState([]);
    const [loadingGroups, setLoadingGroups] = useState(false);
    const [pendingSubmit, setPendingSubmit] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(false);
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [settings, setSettings] = useState([]);
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [deliverPlaces, setDeliverPlaces] = useState({ Data: [] });
    const [productPanelIsHide, setProductPanelToHide] = useState(true);
    const taxPercent = getSettingNumberValue(settings, "TaxPercent", 0);
    const allowNegative = getSettingBoolValue(settings, "AllowNegativeProductCount");

    const details = invoiceData
        .InvoiceDetailList
        .filter(d => !d.SignedForDelete)
        .sort((a, b) => a.Index - b.Index);

    const searchProducts = async ({
        groupId,
        searchType,
        searchText
    }) => {

        /*
         * این قسمت را با API واقعی پروژه جایگزین کنید.
         *
         * مثال:
         *
         * const response = await axios.get(
         *     "/api/products/search",
         *     {
         *         params: {
         *             groupId,
         *             searchType,
         *             searchText
         *         }
         *     }
         * );
         *
         * return response.data;
         */

        console.log({
            groupId,
            searchType,
            searchText
        });

        return [];
    };

    const handleProductSelect = (product, quantity) => {
        setInvoiceData(prev => {
            let rowIndex = 1;

            for (const detail of prev.InvoiceDetailList) {
                if (detail.Index >= rowIndex) {
                    rowIndex = detail.Index + 1;
                }
            }

            const pName = [
                product.HolderName,
                product.Name,
                product.Model
            ]
                .filter(s => s?.trim()?.length > 0)
                .join("-");

            const salePrice = Number(
                product.PriceList?.["SalePrice"] ?? 0
            );

            const totalPrice = quantity * salePrice;
            const tax = totalPrice * taxPercent / 100;
            const pureTotalPrice = totalPrice + tax;

            const newDetail = {
                Index: rowIndex,
                ID: 0,
                ProductID: product.ID,
                ProductName: pName,
                StorageID: product.StorageID,
                StorageName: product.StorageName,
                ProductCount: quantity,
                UnitPrice: salePrice,
                TaxPercent: taxPercent,
                TotalPrice: totalPrice,
                Discount: 0,
                DiscountPercent: 0,
                Tax: tax,
                PureTotalPrice: pureTotalPrice,
            };

            return {
                ...prev,
                InvoiceTotalPrice: prev.InvoiceTotalPrice + totalPrice,
                InvoicePureTotalPrice: prev.InvoicePureTotalPrice + pureTotalPrice,
                TaxFee: prev.TaxFee + tax,
                Discount: 0,
                InvoiceDetailList: [
                    ...prev.InvoiceDetailList,
                    newDetail
                ]
            };
        });
    };
    const getSettings = async () => {
        const names = ["TaxPercent", "ProductGrouppingType", "AllowNegativeProductCount"];
        const result = await getSystemSettingsAsync(names);
        if (Array.isArray(result)) {
            setSettings(result);
        }
    }
    const printInvoice = (e) => {
        setModalPrintData({
            show: true,
            designMode: e.ctrlKey,
            reportName: "FormalSaleInvoice",
            title: "چاپ فاکتور فروش"
        });
    }
    const printInvoice2 = (e) => {
        setModalPrintData({
            show: true,
            designMode: e.ctrlKey,
            reportName: "FormalSaleInvoice2", title: "چاپ دوم فاکتور فروش"
        });
    }
    const popPrintMenu = (
        <Popover style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle" style={{ paddingRight: "3px" }}><Printer size={18} /> چاپ فاکتور فروش </Popover.Title>
            <Popover.Content className="bodyStyle" style={{ paddingRight: "3px" }}>
                <div className="popMenuItem" onClick={printInvoice}><Printer />&nbsp;چاپ فاکتور فروش </div>
                <div className="popMenuItem" onClick={printInvoice2}><PrinterFill />&nbsp;چاپ دوم فاکتور فروش</div>
            </Popover.Content>
        </Popover>
    )
    const handleDeliverPlaces = () => {
        const onGet = (res) => {
            if (Array.isArray(res?.Data)) {
                setDeliverPlaces(res);
            }
        }
        getBaseInfoList(46, onGet);
    }
    const handleProductGroups = () => {
        const onGetPG = (res) => {
            setLoadingGroups(res !== "PENDING");
            if (Array.isArray(res)) {
                setProductGroups(res);
            }
        }
        getProductGroups(0, onGetPG);
    }
    useEffect(() => {
        document.body.classList = "notMain";
        getSettings();
        setLoadingGroups(true);
        handleProductGroups();
        handleDeliverPlaces();
    }, [])


    // const departments = [
    //     {
    //         id: 1,
    //         name: "فروش"
    //     },
    //     {
    //         id: 2,
    //         name: "مالی"
    //     },
    //     {
    //         id: 3,
    //         name: "منابع انسانی"
    //     },
    //     {
    //         id: 4,
    //         name: "فنی"
    //     }
    // ];

    // const [data, setData] = useState([
    //     {
    //         id: 1,
    //         name: "Ali Ahmadi",
    //         age: 25,
    //         salary: 1250000,
    //         departmentId: 4,
    //         isActive: true,
    //         description:
    //             "کارشناس ارشد توسعه نرم‌افزار"
    //     },

    //     {
    //         id: 2,
    //         name: "Reza Mohammadi",
    //         age: 31,
    //         salary: 2500000,
    //         departmentId: 2,
    //         isActive: false,
    //         description:
    //             "کارشناس واحد مالی شرکت"
    //     },

    //     {
    //         id: 3,
    //         name: "Sara Hosseini",
    //         age: 28,
    //         salary: 3200000,
    //         departmentId: 1,
    //         isActive: true,
    //         description:
    //             "مدیر فروش و توسعه بازار"
    //     },

    //     {
    //         id: 4,
    //         name: "Mehdi Karimi",
    //         age: 42,
    //         salary: 4500000,
    //         departmentId: 3,
    //         isActive: true,
    //         description:
    //             "مدیر منابع انسانی سازمان"
    //     },

    //     {
    //         id: 5,
    //         name: "Nima Ahmadi",
    //         age: 35,
    //         salary: 3800000,
    //         departmentId: 4,
    //         isActive: true,
    //         description:
    //             "توسعه‌دهنده ارشد Backend"
    //     }
    // ]);

    /*
     * --------------------------------------
     * Columns
     * --------------------------------------
     */

    const columns = [
        {
            field: "StorageName",
            title: "انبار",
            type: "string",
            required: true,
            hideInEditMode: true,
            readOnly: true
        },
        {
            field: "ProductName",
            title: "مشخصات کالا",
            type: "string",
            required: true,
            readOnly: true
        },

        {
            field: "ProductCount",
            title: "تعداد",
            type: "number",
            style: { width: "1%" },
            dependencies: (value, row) => ({
                TotalPrice: value * row.UnitPrice,
                PureTotalPrice: value * row.UnitPrice - row.Discount + row.Tax
            })
        },

        {
            field: "UnitPrice",
            title: "بهای واحد",
            style: { width: "1%" },
            type: "number",
            required: true,
            dependencies: (value, row) => ({
                TotalPrice: value * row.ProductCount,
                PureTotalPrice: value * row.ProductCount - row.Discount + row.Tax
            })

            // validate: value => {
            //     if (value < 18) {
            //         return "سن باید حداقل 18 باشد";
            //     }

            //     if (value > 100) {
            //         return "سن نمی‌تواند بیشتر از 100 باشد";
            //     }

            //     return null;
            // }
        },
        {
            field: "DiscountPercent",
            title: "%تخفیف",
            style: { width: "1%" },
            type: "number",
            dependencies: (dp, row) => {
                const discount = row.TotalPrice * dp / 100;
                const tax = (row.TotalPrice - discount) * taxPercent / 100;
                const pureTotalPrice = row.TotalPrice - discount + tax;

                return ({
                    Discount: discount,
                    DiscountPercent: dp,
                    Tax: tax,
                    PureTotalPrice: pureTotalPrice
                })
            }
        },

        {
            field: "Discount",
            title: "تخفیف",
            style: { width: "1%" },
            type: "number",
            dependencies: (discount, row) => {
                const tax = (row.TotalPrice - discount) * taxPercent / 100;
                const discountPercent = row.TotalPrice > 0 ? discount / row.TotalPrice * 100 : 0;
                const pureTotalPrice = row.TotalPrice - discount + tax;

                return ({
                    DiscountPercent: discountPercent,
                    Tax: tax,
                    PureTotalPrice: pureTotalPrice
                })
            }
        },

        {
            field: "Tax",
            title: "ارزش افزوده",
            style: { width: "1%" },
            type: "number",
            readOnly: true,
            dependencies: (tax, row) => ({
                PureTotalPrice: row.TotalPrice - row.Discount + tax
            })
            // dataSource: departments,

            // valueField: "id",
            // textField: "name",

            // placeholder:
            //     "انتخاب دپارتمان...",

            // required: true
        },

        {
            field: "PureTotalPrice",
            title: "قابل پرداخت",
            style: { width: "1%" },
            type: "number",
            readOnly: true
        }
    ];

    /*
     * --------------------------------------
     * Actions
     * --------------------------------------
     */
    const handleDeleteRow = (row) => {
        setInvoiceData(prev => {
            const hasId = Number(row.ID) > 0;

            return {
                ...prev,
                Discount: prev.Discount - row.Discount,
                TaxFee: prev.Tax - row.Tax,
                InvoiceTotalPrice: prev.TotalPrice - row.TotalPrice,
                InvoicePureTotalPrice: prev.PureTotalPrice - row.PureTotalPrice,

                InvoiceDetailList: hasId
                    ? prev.InvoiceDetailList.map(d =>
                        d.Index === row.Index
                            ? { ...d, SignedForDelete: true }
                            : d
                    )
                    : prev.InvoiceDetailList.filter(
                        d => d.Index !== row.Index
                    ),
            };
        });
    };
    const handleEditRow = (row) => {
        setInvoiceData(prev => {
            const oldRow = prev.InvoiceDetailList.find(
                d => d.Index === row.Index
            );

            if (!oldRow) {
                return prev;
            }

            const hasId = Number(oldRow.ID) > 0;

            const newDetails = hasId
                ? [
                    ...prev.InvoiceDetailList.map(d =>
                        d.Index === oldRow.Index
                            ? { ...d, SignedForDelete: true }
                            : d
                    ),
                    row
                ]
                : prev.InvoiceDetailList.map(d =>
                    d.Index === oldRow.Index
                        ? row
                        : d
                );

            return {
                ...prev,
                InvoiceDetailList: newDetails
            };
        });
    };
    const actions = [
        {
            title: "ویرایش",
            icon: <Pencil color="orange" />,
            type: "edit",
            onClick: handleEditRow
        },

        {
            title: "حذف",
            icon: <Trash color="red" />,

            onClick: handleDeleteRow

            // visible: row =>
            //     row.isActive === true
        }
    ];

    /*
     * --------------------------------------
     * Controlled Save
     * --------------------------------------
     */

    const handleEditSave = async (updatedRow, originalRow) => {
        setInvoiceData((prevInvoiceData) => {

            /************************ PRICE NORMALIZATION *************************/
            const oldTotalPrice = Number(originalRow.TotalPrice) || 0;
            const oldDiscount = Number(originalRow.Discount) || 0;
            const oldTax = Number(originalRow.Tax) || 0;
            const oldPureTotalPrice = Number(originalRow.PureTotalPrice) || 0;

            const newTotalPrice = Number(updatedRow.TotalPrice) || 0;
            const newDiscount = Number(updatedRow.Discount) || 0;
            const newTax = Number(updatedRow.Tax) || 0;
            const newPureTotalPrice =
                Number(updatedRow.PureTotalPrice) || 0;

            const hasId = Number(originalRow.ID) > 0;

            /************************ ROW DATA UPDATE *************************/
            let updatedDetailList;

            if (hasId) {
                const deletedRow = {
                    ...originalRow,
                    SignedForDelete: true,
                };

                // ردیف جدید
                const newRow = {
                    ...updatedRow,
                    ID: 0,
                    SignedForDelete: false,
                };

                updatedDetailList = [
                    ...prevInvoiceData.InvoiceDetailList.map((row) => {
                        if (row.SignedForDelete) {
                            return row;
                        }
                        return (row.Index === originalRow.Index ? deletedRow : row)
                    }
                    ),
                    newRow,
                ];
            } else {

                updatedDetailList =
                    prevInvoiceData.InvoiceDetailList.map((row) => {
                        if (row.SignedForDelete) {
                            return row;
                        }
                        return (
                            row.Index === originalRow.Index
                                ? {
                                    ...updatedRow,
                                    ID: originalRow.ID,
                                }
                                : row)
                    }
                    );
            }

            /************************ NEW DATA RETURN *************************/
            return {
                ...prevInvoiceData,

                InvoiceDetailList: updatedDetailList,

                InvoiceTotalPrice:
                    (Number(prevInvoiceData.InvoiceTotalPrice) || 0) -
                    oldTotalPrice +
                    newTotalPrice,

                Discount:
                    (Number(prevInvoiceData.Discount) || 0) -
                    oldDiscount +
                    newDiscount,

                TaxFee:
                    (Number(prevInvoiceData.TaxFee) || 0) -
                    oldTax +
                    newTax,

                InvoicePureTotalPrice:
                    (Number(prevInvoiceData.InvoicePureTotalPrice) || 0) -
                    oldPureTotalPrice +
                    newPureTotalPrice,
            };
        });
    };

    const handleSubmitInvoice = async () => {
        if (pendingSubmit) {
            return;
        }
        setPendingSubmit(true);

        if (!(Number(invoiceData.CustomerID) > 0)) {
            const mobileResult = validateMobile(invoiceData.CustomerMobile);
            if (mobileResult.valid) {
                const custData = {
                    Mobile: mobileResult.number,
                    Phone: invoiceData.CustomerPhone,
                    Name: invoiceData.CustomerName,
                    Type: "مرد",
                    CustomerAccountType: true,
                    IsBlackListed: false,
                    Address: "-"
                }
                const custResult = await addNewCustomerAsync(custData);
                if (custResult.Message || custResult.message) {
                    setErrorDialog(dispatch, custResult.Message || custResult.message, "ایجاد مشتری");
                    setPendingSubmit(false);
                    return;
                }
                if (!isNaN(custResult)) {
                    invoiceData.CustomerID = custResult;
                    invoiceData.CustomerCat = 3;
                }
            }
            else {
                if (invoiceData.CustomerName)
                    invoiceData.Description = "نام مشتری: " + invoiceData.CustomerName;
                const custResult = await getDefaultCustomerIDAsync();
                if (custResult.Message || (!Number(custResult?.Data) > 0)) {
                    const msg = custResult.Message ?? "مشتری پیش‌فرض در سیستم وجود ندارد.";
                    setErrorDialog(dispatch, msg, "دریافت اطلاعات مشتری");
                    setPendingSubmit(false);
                    return;
                }
                if (custResult.Data) {
                    invoiceData.CustomerID = custResult.Data;
                    invoiceData.CustomerCat = 3;
                }
            }
        }
        const result = await addEditInvoiceAync(invoiceData);
        setPendingSubmit(false);
        if (result.Message) {
            setErrorDialog(dispatch, result.Message, "ثبت فاکتور سریع");
        }
        if (result.Invoice) {
            setErrorDialog(dispatch, "success", "ثبت فاکتور سریع");
            setInvoiceData(result.Invoice);
        }
    }
    const deleteInvc = () => {
        if (pendingSubmit || pendingDelete) {
            return;
        }
        const onDelete = (res) => {
            setPendingDelete(false);
            if (res === "true" || res === true) {
                setInvoiceData({ ...initData });
            }
        }
        setPendingDelete(true);
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف فاکتور',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteInvoice(invoiceData.InvoiceID, invoiceTypes.Sale, onDelete),
            cancelOperation: () => setPendingDelete(false)
        }))
    }
    const handleChangeInvoiceData = (e) => {
        const name = e.target.name;
        const type = e.target.getAttribute("type");
        const value = type === "number" ? Number(e.target.value ?? 0) : e.target.value;

        if (name) {
            setInvoiceData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleNewInvoice = () => {
        if (loadingInvoice) {
            return;
        }
        setLoadingInvoice(true);
        const onGet = (res) => {
            if (res !== "PENDING") {
                setLoadingInvoice(false);
            }
            if (!isNaN(res)) {
                setInvoiceData({ ...initData, InvoiceNumber: Number(res) });
            }
        }
        getInvoiceNewNumber(invoiceTypes.Sale, true, onGet);
    }
    const handleHideProductPanel = () => {

        setProductPanelToHide(prev => {
            if (prev) {
                panelProductsRef.current.classList.add("hide");
                panelDetailsRef.current.classList.add("fill");
            }
            else {
                panelProductsRef.current.classList.remove("hide");
                panelDetailsRef.current.classList.remove("fill");
            }
            return !prev;
        });
    }


    return (
        <div className="container-fluid">
            <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData}
                dataUrl={`api/InvoiceAPI/GetInvoice?invoiceID=${invoiceData.InvoiceID}&invoiceType=Sale`}
                method="get" />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileInvoice} size="lg"/>&nbsp;
                    فاکتور فروش سریع</Card.Header>
                <Card.Body className="bodyStyle">
                    <Row >
                        <Col md={4} className="product-panel-container rowBorder p-1" ref={panelProductsRef} >
                            <Button variant="outline" onClick={handleHideProductPanel} className="hide-product-panel-button">
                                <FontAwesomeIcon icon={productPanelIsHide?faCaretRight:faCaretLeft} size="2x" color="blue" />
                            </Button>
                            <ProductSelectionPanel
                                productGroups={productGroups}
                                isLoadingGroups={loadingGroups}
                                searchProducts={searchProducts}
                                onProductSelect={handleProductSelect}
                                allowNegative={allowNegative}
                            />
                        </Col>
                        <Col md={8} className="invoice-details-container" ref={panelDetailsRef}>
                            <InvoiceTopHead
                                invoiceData={invoiceData}
                                initData={initData}
                                setInvoiceData={setInvoiceData}
                                loadingInvoice={loadingInvoice}
                                setLoadingInvoice={setLoadingInvoice} />
                            {loadingInvoice ?

                                <Loader className="mt-3" type="BallTriangle" color="#bb1370" width={35} height={35} />
                                : <>
                                    <div className="rowBorder p-1">
                                        <CustomerPanel invoiceData={invoiceData} setInvoiceData={setInvoiceData} />
                                    </div>
                                    <div
                                        dir="rtl"
                                        className="p-3"
                                    >
                                        <DataTable
                                            data={details}
                                            columns={columns}
                                            actions={actions}
                                            rowKey="Index"
                                            editable={true}
                                            editMode="row"
                                            locale="en-US"
                                            loading={false}
                                            emptyMessage="داده‌ای برای نمایش وجود ندارد"
                                            onEditSave={
                                                handleEditSave
                                            }
                                        />
                                    </div>
                                    <Row className="rowBorder p-2 ">
                                        <div className="rowTitle">محل تحویل</div>
                                        <Form.Control className="mt-1"
                                            value={invoiceData.DeliverAddress ?? ""}
                                            name="DeliverAddress"
                                            type="text"
                                            list="dp"
                                            aria-label="محل تحویل"
                                            style={{ fontSize: "12px", fontWeight: 600 }}
                                            onChange={handleChangeInvoiceData} />
                                        <datalist id="dp">
                                            {deliverPlaces.Data.map(
                                                dp =>
                                                    <option data-value={dp.InfoName} key={dp.ID}>
                                                        {dp.InfoName}
                                                    </option>
                                            )}
                                        </datalist>
                                    </Row>
                                    <InvoiceTotalPrices invoiceData={invoiceData} taxPercent={taxPercent} />
                                    <div className="invoice-buttons-row">
                                        <Button variant="success" onClick={handleSubmitInvoice} disabled={pendingSubmit}>
                                            {pendingSubmit ?
                                                <Loader type="TailSpin" width={18} height={18} style={{ display: "inline-block" }} /> :
                                                <CheckLg size={18} />
                                            } &nbsp;
                                            ثبت فاکتور
                                        </Button>
                                        {invoiceData.InvoiceID &&
                                            <OverlayTrigger trigger="click" overlay={popPrintMenu} rootClose>
                                                <Button className="invoice-print-button" disabled={pendingSubmit || pendingDelete}>
                                                    <Printer size={18} /> چاپ فاکتور
                                                </Button>
                                            </OverlayTrigger>}
                                        <Button onClick={handleNewInvoice} disabled={loadingInvoice || pendingSubmit}>
                                            <FileEarmarkPlus size={18} /> فاکتور جدید
                                        </Button>
                                        {invoiceData.InvoiceID &&
                                            <Button variant="danger" onClick={deleteInvc} disabled={pendingSubmit || pendingDelete}>
                                                <Trash3 size={17} /> حذف فاکتور
                                            </Button>}
                                    </div>
                                </>}
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </div>
    );
};

export default NewInvoice;
